import { store } from '../../app/store';
import {
  setSuccessSnackbar,
  setInfoSnackbar,
  setWarningSnackbar,
  setErrorSnackbar,
  resetSnackbar as resetSnackbarReducer,
} from './SnackbarSlice';

export const showSuccessSnackbar = (message) => {
  store.dispatch(
    setSuccessSnackbar({
      open: true,
      message: message ? message : '',
    })
  );
};

export const closeSuccessSnackbar = () => {
  store.dispatch(
    setSuccessSnackbar({
      open: false,
    })
  );
};

export const showInfoSnackbar = (message) => {
  store.dispatch(
    setInfoSnackbar({
      open: true,
      message: message ? message : '',
    })
  );
};

export const closeInfoSnackbar = () => {
  store.dispatch(
    setInfoSnackbar({
      open: false,
    })
  );
};

export const showWarningSnackbar = (message) => {
  store.dispatch(
    setWarningSnackbar({
      open: true,
      message: message ? message : '',
    })
  );
};

export const closeWarningSnackbar = () => {
  store.dispatch(
    setWarningSnackbar({
      open: false,
    })
  );
};

export const showErrorSnackbar = (message) => {
  store.dispatch(
    setErrorSnackbar({
      open: true,
      message: message ? message : '',
    })
  );
};

export const closeErrorSnackbar = () => {
  store.dispatch(
    setErrorSnackbar({
      open: false,
    })
  );
};

export const resetSnackbar = () => {
  store.dispatch(resetSnackbarReducer());
};
